export default "__VITE_ASSET__DsZQ_PGm__"